import Vue from 'vue';
import PurchaseReceipt from '@/classes/purchaseReceipt';

const state = {
  purchaseReceipts: {},
};

const getters = {
  active: (state, getters) => getters.all.filter(pr => pr.active),
  all: (state) => Object.keys(state.purchaseReceipts).map(id => state.purchaseReceipts[id]),
  get: (state) => state.purchaseReceipts,
  unrealized: (state, getters) => getters.all.filter(pr => pr.unrealized),
};

const mutations = {
  set(state, purchaseReceipts) {
    purchaseReceipts.forEach(pr => {
      const purchaseReceipt = new PurchaseReceipt(pr);
      Vue.set(state.purchaseReceipts, purchaseReceipt.id, purchaseReceipt);
    });
    state.purchaseReceipts = purchaseReceipts.map(pr => new PurchaseReceipt(pr));
  },
};

const actions = {
  activate({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/purchase_receipts/activate', params).then(response => {
      if (response.data.user) {
        dispatch('user/setUser', response.data.user, { root: true });
      }
      return response;
    });
  },
  create({ dispatch, commit, getters, rootGetters }) {
    return rootGetters['session/ajax'].post('/purchase_receipts').then(response => {
      if (response.data.user) {
        dispatch('user/setUser', response.data.user, { root: true });
      }
      return response;
    });
  },
  expire({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/purchase_receipts/expire', params).then(response => {
      if (response.data.user) {
        dispatch('user/setUser', response.data.user, { root: true });
      }
      return response;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
